module.exports = __webpack_public_path__ + "static/assets/22994b603f2bf953a84108b2bfd86537.svg";